<ion-header>
  <ion-toolbar class="header-toolbar">
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="getDefaultHref()"></ion-back-button>
    </ion-buttons>
    <ion-title>{{'ATHLETE_INFO.ATHLETE' | translate}}</ion-title>
    
    @if (form.valid) {
      <img
        alt="Point"
        style="margin-right: 10px;"
        src="assets/icon/whites/point.svg" width="25" slot="end"
        (click)="gotNextPage()"
        (keypress)="gotNextPage()" />
    }
  </ion-toolbar>
</ion-header>

<ion-content>
  <br/>
  <div class="ion-text-center">
    <img src="assets/icon/colors/account.svg" alt="Account" width="90" />
    <div class="ion-padding">
      <br/>
      <span style="color: var(--ion-color-tertiary)">{{'ATHLETE_INFO.MESSAGE_OWNER_INFO' | translate}}</span>
    </div>
  </div>
  @if (!!form) {
    <form [formGroup]="form" class="ion-padding">
      <ion-grid>
        <ion-row>
          <ion-col size-md="12">
            <ion-item>
              <ion-input labelPlacement="stacked" formControlName="fullName">
                <div slot="label">{{'ATHLETE_INFO.FULLNAME' | translate}}</div>
              </ion-input>
            </ion-item>
            @if (form.get('fullName')?.invalid && (form.get('fullName')?.dirty || form.get('fullName')?.touched)) {
              <ion-error class="ion-padding form-error-message">
                @if (form.get('fullName')?.errors?.['required']) {
                  <span>{{'ATHLETE_INFO.FULL_NAME_REQUIRED' | translate}}</span>
                }
              </ion-error>
            }
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-md="12">
            <ion-item>
              <ion-input labelPlacement="stacked" label="CPF*"
                style="text-align: left;" formControlName="cpf"
                type="text" [maskito]="cpfMaskitoOptions"
                [maskitoElement]="cpfPredicate"
              ></ion-input>
            </ion-item>
            @if (form.get('cpf')?.invalid && (form.get('cpf')?.dirty || form.get('cpf')?.touched)) {
              <ion-error class="ion-padding form-error-message">
                @if (form.get('cpf')?.errors?.['required']) {
                  <span>{{'ATHLETE_INFO.CPF_REQUIRED' | translate}}</span>
                }
                @if (isCPFInvalid()) {
                  <span>{{'ATHLETE_INFO.CPF_MUST_BE_VALID' | translate}}</span>
                }
              </ion-error>
            }
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-md="6">
            <ion-item>
              <ion-input labelPlacement="stacked"
                formControlName="cellphone" type="text"
                [maskito]="phoneMaskitoOptions"
                [maskitoElement]="phonePredicate">
                <div slot="label">{{'ATHLETE_INFO.PHONE' | translate}}</div>
              </ion-input>
            </ion-item>
            @if (form.get('cellphone')?.invalid && (form.get('cellphone')?.dirty || form.get('cellphone')?.touched)) {
              <ion-error class="ion-padding form-error-message">
                @if (form.get('cellphone')?.errors?.['required']) {
                  <span>{{'ATHLETE_INFO.PHONE_REQUIRED' | translate}}</span>
                }
              </ion-error>
            }
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-md="6">
            <ion-item>
              <ion-input labelPlacement="stacked"
                value="{{ form.get('birthDate')?.value | date: 'dd/MM/yyyy' }}"
                id="date"
                style="text-align: left;"
                >
                <div slot="label">{{'ATHLETE_INFO.BIRTHDATE' | translate}}</div>
              </ion-input>
              <ion-popover trigger="date" size="cover">
                <ng-template>
                  <ion-datetime
                    presentation="date"
                    formControlName="birthDate"
                    display-format="DD MM YYYY"
                    [locale]="getLocale()"
                  ></ion-datetime>
                </ng-template>
              </ion-popover>
            </ion-item>
            @if (form.get('birthDate')?.invalid && (form.get('birthDate')?.dirty || form.get('birthDate')?.touched)) {
              <ion-error class="ion-padding form-error-message">
                @if (form.get('birthDate')?.hasError('required')) {
                  <span>{{'ATHLETE_INFO.BIRTHDATE_REQUIRED' | translate}}</span>
                }
              </ion-error>
            }
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-input labelPlacement="stacked" formControlName="email" (ionChange)="onEmailChange()">
                <div slot="label">{{'ATHLETE_INFO.EMAIL' | translate}}</div>
              </ion-input>
            </ion-item>
            <div class="ion-padding">
              @if ((isLoading$ | async) === true) {
                <div class="ion-text-center">
                  <ion-spinner name="dots"></ion-spinner>
                </div>
              }
              @if ((isEmailValid$ | async) === true) {
                <div class="ion-text-center form-error-message">
                  <div slot="label">{{'ATHLETE_INFO.EMAIL' | translate}}</div>
                </div>
              }
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  }
</ion-content>

<ion-footer no-border>
  <ion-toolbar class="toolbar-footer">
    <div class="ion-text-center ion-padding-top">
      <ion-button class="custom-button" fill="outline" [disabled]="(isEmailValid$ | async) === true" color="primary" expand="block"
        (click)="gotNextPage()" (keypress)="gotNextPage()">
        <span>{{'ATHLETE_INFO.NEXT' | translate}}</span>
        <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
